module.exports = __webpack_public_path__ + "img/v6.e55bb336.png";